import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const buttonStyle = style({
    marginTop: TabStyles.Spacing.SmallSpace
});

export const addOAuthClientDialogStyle: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    paddingTop: '18px',
    paddingBottom: '12px',
    paddingLeft: '12px',
    paddingRight: '12px'
};
